import { render, staticRenderFns } from "./SupplierCollectionDocuments.vue?vue&type=template&id=4a5912a2&scoped=true&"
import script from "./SupplierCollectionDocuments.vue?vue&type=script&lang=js&"
export * from "./SupplierCollectionDocuments.vue?vue&type=script&lang=js&"
import style0 from "./SupplierCollectionDocuments.vue?vue&type=style&index=0&id=4a5912a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5912a2",
  null
  
)

export default component.exports